"use client";
import AppLayout from "@/components/app/applayout";
import Hero from "@/components/app/services/Hero";
import ServiceCard from "@/components/app/services/serviceCard";
import { services } from "@/util/data/serviceData";
import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";
import { pxToRem, AppSize } from "@/util";
import Faq from "@/components/home/faq";
import { serviceFaqData } from "@/util/data/serviceFaqData";
import Getintouch from "@/components/home/Getintouch";
import { AppColors } from "@/assets/colors";
import WhyReason from "@/components/app/services/why";
import { whyData as Data } from "@/util/data/serviceData";
import { IReasonData } from "@/util/types";

export default function Service() {
  const { classes } = styles();
  return (
    <AppLayout>
      <Hero />
      <Box className={classes.container}>
        <Box className={classes.subCont}>
          <Typography className={classes.service}>All Our Services</Typography>
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={service.title}
              description={service.description}
              image={service.image}
              reverse={index % 2 !== 0}
            />
          ))}
        </Box>
        <Box className={classes.why}>
          {" "}
          <Typography className={classes.container1}>
            {" "}
            Why Choose Arel for These{" "}
            <span className={classes.duplicate}>Services?</span>
          </Typography>
          <Typography></Typography>
        </Box>

        <WhyReason
          mainImg="/images/service/selling_point.svg"
          reasons={Data as IReasonData[]}
        />
      </Box>
        <Faq faqData={serviceFaqData} />
      <Getintouch />
    </AppLayout>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: `0px ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(2)} ${pxToRem(20)}`,
    },
  },
  subCont: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  view: {
    display: "flex",
    flexDirection: "row",
    gap: pxToRem(50),
    padding: theme.spacing(4),
    justifyContent: "center",
  },
  container1: {
    fontFamily: "Playfair Display",
    fontSize: pxToRem(48),
    fontWeight: "700",
    color: `${AppColors.text.default}`,
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(36),
      textAlign: "center",
      width: "120%",
    },
  },
  duplicate: {
    fontFamily: "Playfair Display",
    fontSize: pxToRem(48),
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(40),
      textAlign: "center",
    },
  },
  general: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  service: {
    fontFamily: "Playfair Display",
    fontSize: pxToRem(48),
    fontWeight: "bold",
    textAlign: "center",
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(35),
      padding: pxToRem(0),
      textAlign: "center",
    },
  },
  why: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} ${pxToRem(20)}`,
    },
  },
}));
